import PropTypes from 'prop-types';
import React from 'react';

function LinkedInSVG({ width, height, fill }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.52376 1.3663C3.52376 2.12105 2.89767 2.73261 2.12494 2.73261C1.35221 2.73261 0.726125 2.12105 0.726125 1.3663C0.726125 0.612104 1.35221 0 2.12494 0C2.89767 0 3.52376 0.612104 3.52376 1.3663ZM3.53504 3.82565H0.714844V12.57H3.53504V3.82565ZM8.03719 3.82565H5.23505V12.57H8.03776V7.97976C8.03776 5.42751 11.4383 5.21874 11.4383 7.97976V12.57H14.2518V7.03319C14.2518 2.7266 9.21942 2.88345 8.03719 5.00341V3.82565Z"
        fill={fill}
      />
    </svg>
  );
}

LinkedInSVG.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

export default LinkedInSVG;
